


































































































import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import { ShopifyEditorForm } from "../forms/ShopifyEditorForms";
import { Shop } from "../../shop/models/Shop";
import { DeliveryMode } from "../../delivery-modes/models/DeliveryMode";

export default Vue.extend({
  props: {
    value: {
      type: Object as () => ShopifyEditorForm
    },
    shops: {
      type: Array as () => Shop[]
    },
    deliveryModes: {
      type: Array as () => DeliveryMode[]
    },
    validations: {
      type: Object
    },
    state: {
      type: String
    }
  },
  computed: {
    ...proxyModel(
      "shop",
      "deliveryMode",
      "shopName",
      "token",
      "hostname",
      "mcApiKey",
      "mcSecretkey",
      "locationId"
    ),
    isUpdateState() {
      return (this as any).state === "UPDATE";
    },
    shopError() {
      return (this as any).validations.shop.$error
        ? "shop is required or invalid"
        : "";
    },
    shopNameError() {
      return (this as any).validations.shopName.$error
        ? "shopName is required or invalid"
        : "";
    },
    tokenError() {
      return (this as any).validations.token.$error
        ? "Token is required or invalid"
        : "";
    },
    hostnameError() {
      return (this as any).validations.hostname.$error
        ? "Hostname is required or invalid"
        : "";
    },
    mcApiKeyError() {
      return (this as any).validations.mcApiKey.$error
        ? "MC API Key is required or invalid"
        : "";
    },
    mcSecretkeyError() {
      return (this as any).validations.mcSecretkey.$error
        ? "MC Secret Key is required or invalid"
        : "";
    },
    deliveryModeIdError() {
      return (this as any).validations.deliveryMode.$error
        ? "Delivery Mode is required or invalid"
        : "";
    },
    locationIdError() {
      return (this as any).validations.locationId.$error
        ? "Location Id is required or invalid"
        : "";
    }
  },
  methods: {
    selectDeliveryMode(shop: Shop) {
      this.$emit("selectDeliveryMode", shop.id);
    }
  }
});
